export const getContactsQueryKey = () => ['contacts'] as const;
export type ContactsQueryKey = ReturnType<typeof getContactsQueryKey>;
